<template>
  <div class="columns is-multiline">
    <p
      class="is-large has-text-grey-dark filters__result-text"
      aria-live="assertive"
      role="alert"
      v-html="resultText"
    ></p>
    <div class="services__filters-header column is-10 is-8-desktop">
      <h2 class="resources__filters-title">Filters:</h2>
      <button class="services__reset" title="Reset filters" @click="updateFilters(true)">
        <span class="icon icon--reset"><reset-svg></reset-svg></span>
        <span>Reset Filters</span>
      </button>
    </div>
    <div class="column is-5 is-4-desktop">
      <div class="select is-grey-dark is-filter">
        <select
          aria-label="Filter resources by topic"
          required
          v-model="selectedTopic"
          @change="updateFilters(false)"
        >
          <option value="">{{ topics.name }}</option>
          <option
            v-for="topic in topics.value"
            :key="topic.id"
            :value="topic.id"
          >
            {{ topic.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="column is-5 is-4-desktop">
      <div class="select is-grey-dark is-filter">
        <select
          aria-label="Filter resources by audience"
          required
          v-model="selectedAudience"
          @change="updateFilters(false)"
        >
          <option value="">{{ audiences.name }}</option>
          <option
            v-for="audience in audiences.value"
            :key="audience.id"
            :value="audience.id"
          >
            {{ audience.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import ResetSvg from '@/components/svg/reset.vue';

export default {
  name: 'resource-filter',
  components: { ResetSvg },
  props: {
    topics: Object,
    audiences: Object,
    resultCount: Number,
  },
  computed: {
    selectedTopic: {
      get() {
        return this.$store.state.selectedTopic;
      },
      set(value) {
        this.$store.commit('setSelectedTopic', value);
      },
    },
    selectedAudience: {
      get() {
        return this.$store.state.selectedAudience;
      },
      set(value) {
        this.$store.commit('setSelectedAudience', value);
      },
    },
    searchTerm: {
      get() {
        return this.$store.state.searchTerm;
      },
      set(value) {
        this.$store.commit('setSearchTerm', value);
      },
    },
    resultText() {
      const filters = this.searchTerm ? [this.searchTerm] : [];
      const topic = this.topics.value.filter(item => item.id === this.selectedTopic);
      if (topic.length > 0) {
        filters.push(topic[0].name);
      }
      const audience = this.audiences.value.filter(item => item.id === this.selectedAudience);
      if (audience.length > 0) {
        filters.push(audience[0].name);
      }
      const filterText = filters.length > 0 ? ` for <b>${filters.join('</b> and <b>')}</b>` : '';
      const results = this.resultCount === 1 ? 'result' : 'results';
      return `<b>${this.resultCount} ${results}</b>${filterText}`;
    },
  },
  methods: {
    /**
     * Emit update event to parent. Optionally clear filters before update
     * @param { Boolean } reset - If set, will clear the filters before emitting update
     */
    updateFilters(reset) {
      if (reset) {
        this.selectedTopic = '';
        this.selectedAudience = '';
        this.searchTerm = '';
      }
      this.$emit('update-filter');
    },
  },
};
</script>
